<template>
  <div class="user_Dialogue w-full flex justify-end" ref="user_Dialogue">
    <div class="chat-content-quote">
      <div class="chat-content-quote-text p-3">
        <!-- <p>{{ itemData.text }}</p> -->
        <div class="results_en">
          <p class="m-0 p-0" v-if="$route.name === 'ChatAI'"><span ref="item" class="m-0 p-0" v-for="(item, index) in sentenceSpliter" :key="index" :class="{ 'active': dictIdx === index, 'cursor-pointer isDictionary': isDictionary && !isRegular(item) }" @click.stop="setIdxEn(item, index)">{{ item }}<WordDict v-click-outside="onClickOutside" class="hidden lg:block" v-if="dictIdx === index" v-on:closeDict="closeDict" :content="ductWord" :isRightSide="isRightSide" /></span></p>
          <p class="m-0 p-0" v-if="$route.name === 'ChatAIJp' || $route.name === 'viewChat'">{{ tidyText }}</p>
        </div>

        <p v-if="selectedStep === 1 && grammarSugges && isOpenGrammar" class="tips-suggestion mt-2 pt-2">
          {{ lang === 'zh' ? grammarSugges : grammarSugges_en }}
        </p>
        <p v-if="selectedStep === 1 && isOpenSimilar && isOpenSimilar" class="tips-suggestion mt-2 pt-2">
          {{ similarSentences }}
        </p>
      </div>
      <div class="robot_btns flex items-center mt-2 justify-end" v-if="selectedStep === 1">
        <!-- <a class="tooltip-outer flex justify-center items-center mr-1 cursor-pointer" v-if="chatHistory && chatHistory.audio" @click="audio_play()">
          <img src="@/assets/image/ai/btn_AItalk_voice.png" class="mr-1">
          <span class="tooltiptext" :class="{ 'instructions_tooltip' : lang === 'en' }">{{ $t('hover.my_voice') }}</span>
        </a> -->
        <UserVoice :ttsUrl="chatHistory.audio" v-if="chatHistory && chatHistory.audio" />
        <a @click="toggle_more_instructions()" class="tooltip-outer flex justify-center items-center mx-1 cursor-pointer">
          <div class="relative">
            <img v-if="isOpenGrammar && grammarSugges && !isLoadingSuggest" src="@/assets/image/ai/btn_AItalk_correct_active.png">
            <img v-else src="@/assets/image/ai/btn_AItalk_correct.png">
            <img v-if="isLoadingSuggest" src="@/assets/image/ai/loading_circle.png" class="absolute loading_circle">
          </div>
          <span class="tooltiptext" :class="{ 'instructions_tooltip' : lang === 'en' }">{{ $t('hover.more_instructions') }}</span>
        </a>
        <!-- <a v-if="similarSentences" @click="toggleDirections('similar')" class="tooltip-outer flex justify-center items-center cursor-pointer">
          <img v-if="!isOpenSimilar" src="@/assets/image/ai/btn_AItalk_resemblance.png">
          <img v-if="isOpenSimilar" src="@/assets/image/ai/btn_AItalk_resemblance_active.png">
          <span class="tooltiptext">換句話說</span>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import dictApi from '@/dictApi'
import WordDict from '@/components/AiHelper/WordDict'
import UserVoice from '@/components/AiHelper/chat/UserVoice'
export default {
  name: 'userDialogue',
  props: {
    itemData: {
      type: Object
    },
    selectedStep: {
      type: Number
    },
    theme: {
      type: String
    },
    context: {
      type: String
    },
    chatHistory: {
      type: Object
    },
    isDisabledInput: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WordDict,
    UserVoice
  },
  data () {
    return {
      grammarSugges: null,
      grammarSugges_en: null,
      similarSentences: null,

      isOpenGrammar: false,
      isOpenSimilar: false,

      ductWord: null,
      dictIdx: -1,
      isDictionary: true,
      isFinishTyped: false,

      sound_effect: null,

      isRightSide: false,
      isLoadingSuggest: false
    }
  },
  watch: {
    'chatHistory': {
      handler (newVal, oldVal) {
        let self = this
        if (newVal !== oldVal && newVal) {
          self.sound_effect = new Audio(self.chatHistory.audio)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
    tidyText () {
      if (this.lang === 'en' && this.itemData.text_en) {
        return this.itemData.text_en.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      }
      return this.itemData.text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
    },
    sentenceSpliter () {
      if (!this.tidyText) return []
      let str = this.tidyText
      const pattern = /\p{L}[\p{L}\p{N}]*(?:['’\-][\p{L}\p{N}]+)*|\p{N}+|[^\p{L}\p{N}'’\-\s]|\s+/gu

      return str.match(pattern) || []
    }
  },
  mounted () {
    this.$route.name !== 'viewChat' ? this.getData() : null
  },
  methods: {
    onClickOutside () {
      this.closeDict()
    },
    getData () {
      let self = this
      if (self.itemData && self.itemData.text && self.selectedStep === 1 && self.theme && self.context) {
        self.grammar_suggestions(self.itemData.text)
      }
    },

    PlayAudioStandard () {
      let self = this
      if (self.$refs.audioplayer) {
        let audioplayer = self.$refs.audioplayer
        // 判斷是否播放中
        audioplayer.onplaying = () => {
          self.isPlaying = true
        }
        audioplayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioplayer.pause()
          audioplayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioplayer.play()
          self.isPlaying = true
        }
      }
    },

    grammar_suggestions (text) {
      // 更多說明 zh
      let self = this
      let prompt_id = '6b2607ab-2280-4cc0-b910-f60f4619d8e1'

      if (self.$route.name === 'SpeechAIJp' || self.$route.name === 'ChatAIJp') {
        prompt_id = 'aa92185b-43c2-4a86-98c5-00bfd9093b3d'
      }
      let path = `/ai/generate/${prompt_id}`
      self.isLoadingSuggest = true

      api.post(path, {
        theme: self.theme,
        context: self.context,
        content: text
      })
      .then((res) => {
        self.grammarSugges = res.data.result
        self.isLoadingSuggest = false
      })
      .catch(() => {
      })
    },
    // grammar_suggestions_en (text) {
    //   // 更多說明 en
    //   let self = this

    //   let  path = `/ai/generate/1589e0ec-6a5d-4e01-b58f-2a153c3791dd`

    //   api.post(path, {
    //     theme: self.theme,
    //     context: self.context,
    //     content: text
    //   })
    //   .then((res) => {
    //     self.grammarSugges_en = res.data.result
    //   })
    //   .catch(() => {
    //   })
    // },

    getSimilarSentences (text) {
      // 換句話說
      let self = this

      let path = `/ai/generate/3a01a966-cf24-4d92-a6f2-aba2899ab3be`

      api.post(path, {
        content: text
      })
      .then((res) => {
        self.similarSentences = res.data.result
      })
      .catch(() => {
      })
    },
    async toggle_more_instructions () {
      let self = this
      if (!self.grammarSugges) {
        await self.getData()
      }

      self.isOpenGrammar = !self.isOpenGrammar
      self.isOpenSimilar = false
    },
    toggleDirections () {
      let self = this
      self.isOpenSimilar = !self.isOpenSimilar
      self.isOpenGrammar = false
    },

    judgeGrammarCorrect (result) {
      if (result.indexOf('更正句子') > -1 || result.indexOf('修正句子') > -1) {
        return true
      }
      return false
    },

    closeDict () {
      let self = this
      self.ductWord = null
      self.dictIdx = -1

      self.isRightSide = false
    },

    async setIdxEn (item, idx) {
      let self = this

      let outerElement = self.$refs.user_Dialogue
      let innerElement = self.$refs.item[idx]
      let outerRight = outerElement.getBoundingClientRect().right
      let innerRight = innerElement.getBoundingClientRect().right
      let distance = outerRight - innerRight

      if (self.isDictionary && !self.isRegular(item)) {
        const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${item}`)
        self.dictIdx = idx
        self.ductWord = data.data

        distance < 325 ? self.isRightSide = true : self.isRightSide = false
      }
    },

    isRegular (val) {
      // eslint-disable-next-line no-useless-escape
      let pattern = new RegExp(/[\p{P}\s]/u)
      if (val && val.match(pattern)) {
        return true
      }
      return false
    },

    audio_play () {
      this.sound_effect.play()
    }
  }
}
</script>
<style lang="scss" scoped>
  .loading_circle {
    top: 15%;
    left: 15%;
    transform: translate(-50%, -50%);
    animation: spin 2s infinite linear;
    transform-origin: center;
  }
  @keyframes spin  {
    from {
      transform: rotate(0deg);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
  .user_Dialogue {
    min-height: 96px;
  }
  .results_en {
    p {
      white-space: pre-line;
      word-break: normal;
      margin-bottom: 0;
      span {
        position: relative;
      }
      // .dict_chat {
      //   left: auto !important;
      //   right: 0 !important;
      // }
      .isDictionary {
        &:hover {
          background-color: #BBDDFF;
        }
      }
      .active {
        background-color: #BBDDFF;
      }
    }
  }
  .chat-content-quote {
    font-weight: 700;
    max-width: 80%;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
    @media (max-width: 768px) {
      max-width: 95%;
    }
    .chat-content-quote-text {
      background-color: #FFF3DD;
      border-bottom-left-radius: 20px 20px;
      border-top-left-radius: 20px 20px;
      border-top-right-radius: 20px 20px;
      .option-item {
        width: 25%;
        text-align: center;
      }
      .tips-suggestion {
        border-top: 1px solid #E28049;
        border-style: dashed none none;
        color: #E28049;
      }
    }
  }
  .robot_btns {
    .instructions_tooltip {
      right: -30%;
      left: auto;
      transform: translateX(0);
      &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 80%;
        transform: translateX(-50%);
      }
    }
  }
</style>
